import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form/immutable'
import { Map, List } from 'immutable'
import i18next from 'i18next'
import { withTranslation } from 'react-i18next'
import { EStoppedFrom } from '@prohabits/metaverse'

import {
  getOrganizationTeams,
  getOrganizationUsersOrganizationId,
  getOrganizationUsersSelectedOrganizationAvailableProTrackLevels,
  getFirstHistorySwitchProTrackLevels,
} from 'store/entities/organizations/selectors'
import { isSuperOrMultiAdmin } from 'store/entities/identity/selectors'
import {
  fetchAvailableProTrackLevelsForSelectedOrg,
  manageUsers,
  fetchSwitchProTrackLevelsHistory,
} from 'store/entities/organizations/actions'
// @ts-ignore
import withDidMountRequest from 'app/connectors/withDidMountRequest'
import BulkManagementForm from './BulkManagementForm'
import { BULK_MANAGEMENT_FORM_TYPE } from 'app/constants/bulkManagement'
import {
  IBulkManagementFormDispatchProps,
  IBulkManagementFormOwnProps,
  IBulkManagementFormStateProps,
  IOnSubmitParams,
} from './interface'

export const FORM_NAME = 'BULK_MANAGEMENT_FORM'
const formSelector = formValueSelector(FORM_NAME)

const formProps = {
  form: FORM_NAME,
  initialValues: Map({
    switchStoppedUsers: false,
    entireOrg: false,
    teams: List(),
    proTrackLevelId: '0',
    emails: '',
    stoppedFrom: EStoppedFrom.ADMIN_PANEL,
  }),
  onSubmit: (values: any, dispatch: any, { selectedOrgId, formType }: IOnSubmitParams) => {
    const data = values.toJS()
    data.organizationId = selectedOrgId
    if (formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK) {
      data.proTrackLevelId = parseInt(data.proTrackLevelId)
    } else {
      delete data.proTrackLevelId
    }
    dispatch(manageUsers({ data, formType }))
  },
}

const mapStateToProps = (state: any) => {
  const teamsOptions = getOrganizationTeams(state).toJS()
  return {
    teams: teamsOptions,
    selectedOrgId: getOrganizationUsersOrganizationId(state),
    proTrackLevels: getOrganizationUsersSelectedOrganizationAvailableProTrackLevels(state),
    isEntireOrg: formSelector(state, 'entireOrg'),
    emailsValue: formSelector(state, 'emails'),
    teamsValue: formSelector(state, 'teams'),
    isSuperOrMultiAdmin: isSuperOrMultiAdmin(state),
    firstHistorySwitch: getFirstHistorySwitchProTrackLevels(state),
  }
}

const mapDispatchToProps = {
  fetchAvailableProTrackLevelsForSelectedOrg,
  fetchSwitchProTrackLevelsHistory,
}

const mergeProps = (
  { selectedOrgId, proTrackLevels, emailsValue, teamsValue, isEntireOrg, ...stateProps }: IBulkManagementFormStateProps,
  { fetchAvailableProTrackLevelsForSelectedOrg, fetchSwitchProTrackLevelsHistory }: IBulkManagementFormDispatchProps,
  { t, ...ownProps }: IBulkManagementFormOwnProps
): any => {
  const proTrackLevelOption = i18next.t('Please select')
    ? `${i18next.t('Please select')} ${i18next.t('ProTrackLevel')}`
    : 'Please select ProTrackLevel'
  return {
    ...stateProps,
    ...ownProps,
    proTrackLevels: typeof proTrackLevels === 'object' ? proTrackLevels.unshift(proTrackLevelOption) : '0',
    onRequest: () => {
      fetchAvailableProTrackLevelsForSelectedOrg(selectedOrgId)
      fetchSwitchProTrackLevelsHistory(selectedOrgId)
    },
    isWaitingProTrackLevels: !proTrackLevels.size,
    selectedOrgId,
    isEmailsEnter: typeof emailsValue === 'string' ? !!emailsValue.length : false,
    isTeamsEnter: typeof teamsValue === 'object' ? !!teamsValue.size : false,
    isEntireOrg: typeof isEntireOrg === 'boolean' ? isEntireOrg : false,
  }
}

export default connect(
  // @ts-ignore
  mapStateToProps,
  // @ts-ignore
  mapDispatchToProps,
  mergeProps
)(reduxForm(formProps)(withDidMountRequest(withTranslation()(BulkManagementForm))))
